import React from 'react';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { GridCellParams } from '@mui/x-data-grid';
import { useGridApiContext } from '@mui/x-data-grid-pro';
import { Checkbox } from '@mui/material';
import { handleGridCellChange } from './changeDetectionHelper';

const CheckboxCellEdit = React.memo(function CheckboxCellEdit(props: any) {
  const { id, value, field } = props;
  const apiRef = useGridApiContext();

  const handleChange = async event => {
    const newValue = event.target.checked;
    
    // Use the helper function for change detection
    await handleGridCellChange({
      id,
      field,
      newValue,
      oldValue: value,
      apiRef,
    });
  };

  return (
    <Checkbox
      disableFocusRipple
      disableRipple
      disableTouchRipple
      checked={value}
      onChange={handleChange}
      color="primary"
    />
  );
});

const DisabledCheckbox = React.memo(function DisabledCheckbox(props: any) {
  const { value } = props;
  return <Checkbox disableFocusRipple disableRipple disableTouchRipple checked={value} color="primary" disabled />;
});

export const GridCellCheckboxEdit = (params: GridCellParams) => {
  const { field, row } = params;
  return field !== 'currentlyEmployed' && row?.isTimeOff ? (
    <DisabledCheckbox {...params} />
  ) : (
    <CheckboxCellEdit {...params} />
  );
};

const CheckboxCellView = React.memo(function CheckboxCellView(params: any) {
  return (
    <div style={{ alignItems: 'center' }}>
      {params.value ? (
        <CheckBoxIcon color="primary" />
      ) : (
        <CheckBoxOutlineBlankIcon sx={{ color: 'rgba(0, 0, 0, 0.6)' }} />
      )}
    </div>
  );
});

export const GridCellCheckboxView = (params: GridCellParams) => {
  return <CheckboxCellView {...params} />;
};
